// src/contexts/produtos/NCMContext.js
// contexts/produtos/NCMContext.js
import { createContext, useContext, useRef, useState } from 'react';
import { buscarNCMs, buscarNcmPorCodigo } from '../../services/produtos/NCMService';
import { useMessage } from '../geral/MessageContext';
import { NCM } from '../../models/produtos/NCM';

const NCMContext = createContext();

export const useNCM = () => useContext(NCMContext);

export const NCMProvider = ({ children }) => {
    const [NCMs, setNCMs] = useState([]);
    const [ncmSel, setNcmSel] = useState(new NCM());
    const consultaRef = useRef(null);
    const { showMessage } = useMessage();

    // useEffect(() => {
    //     const fetchDataFromAPI = async () => {
    //         try {
    //             const result = await fetchData('/NCM');
    //             setNCMs(result);                
    //         } catch (error) {
    //             console.error("Erro ao buscar NCMs:", error);
    //             showMessage(error);
    //         }
    //     };
    //     fetchDataFromAPI();
    // }, []);

    const fetchNCMs = async () => {
      try {
            if (NCMs.length===0)
            {
              const result = await buscarNCMs();
              setNCMs(result || []);
            }
                             
          } catch (error) {
              console.error("Erro ao buscar NCMs:", error);
              showMessage('Erro ao buscar NCMs!\n' + error, 'danger');
          }    
      }
    const fetchNcmByCodigo = async (codigo) => {
        const consulta = {};
        consultaRef.current = consulta;
        setNcmSel(new NCM());
        if (!codigo) return;

        if (NCMs.length > 0) {
            setNcmSel(NCMs.find(ncm => String(ncm.codigo) === String(codigo)) || new NCM());
            return;
        }

        try {
            const result = await buscarNcmPorCodigo(codigo);
            if (consultaRef.current === consulta) setNcmSel(result || new NCM());
        } catch (error) {
            if (consultaRef.current !== consulta) return;
            console.error("Erro ao buscar NCMs:", error);
            showMessage('Erro ao buscar NCMs!\n' + error, 'danger');
        }
    }


    return (
        <NCMContext.Provider value={{ NCMs, ncmSel, fetchNcmByCodigo, fetchNCMs }}>
            {children}
        </NCMContext.Provider>
    );
};
